import styled from 'styled-components';
import { COLOR } from '../../../../packages/constants';
import { AccountCell } from '../account-cell/account-cell';

interface StyledScrollbarProps {
    dataGridWidth: number | null;
}
interface ScrollProps {
    disabled: boolean;
}

/* removes the default scroll bar to the data grid table for: */
export const removeScrollbar = `
    /* - IE and Edge */
    -ms-overflow-style: none;
    /* - Firefox */
    scrollbar-width: none;
    /* - Webkit */
    &::-webkit-scrollbar {
        display: none;
    }
`;

export const DataGridScroller = styled.div<ScrollProps>`
    box-sizing: border-box;
    background-color: ${COLOR.PRIMARY.WHITE};
    border-left: 1px solid ${COLOR.MAIN.FORM_FIELD};
    overflow: ${(props) => (props.disabled ? 'hidden' : 'auto')};
    width: 100%;

    ${removeScrollbar}

    ${AccountCell} {
        &:last-child {
            border-right: 0;
        }
    }
`;

export const StyledScrollbarWrapper = styled.div<ScrollProps>`
    height: 17px;
    overflow-y: hidden;
    overflow-x: ${(props) => (props.disabled ? 'hidden' : 'auto')};
    position: sticky;
    bottom: 0;
`;

export const StyledScrollbar = styled.div<StyledScrollbarProps>`
    height: 17px;
    width: ${(props) => (props.dataGridWidth ? `${props.dataGridWidth}px` : '0')};
`;

export const StyledDataGrid = styled.div`
    box-sizing: border-box;
    border-top: 1px solid ${COLOR.MAIN.FORM_FIELD};
    border-right: 1px solid ${COLOR.MAIN.FORM_FIELD};
    border-bottom: 1px solid ${COLOR.MAIN.FORM_FIELD};
    display: flex;
    justify-content: space-between;
    flex-direction: column;
`;

export const StyledDataGridInner = styled.div`
    display: flex;
    flex-direction: row;
`;
